import React from 'react';
import { WorkspaceHero } from '../components/WorkspaceHero';
import { NovaSection } from '../components/nova/NovaSection';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
// Exploration variant of the home page. Identical to Home, but the hero is
// reimagined as an animated Slack/Teams workspace where colleagues @mention
// Giga and Giga replies with finished work — a place to explore the
// "chat box as a real workspace" direction.
export function WorkspaceHome() {
  return <>
      <WorkspaceHero data-id="element-5310" />
      <NovaSection data-id="element-5311" />
      <AudienceSwitch data-id="element-5312" />
      <LivesInSlack data-id="element-5313" />
      <ComputerUse data-id="element-5314" />
      <CapabilityGrid data-id="element-5315" />
      <NarrativeSection data-id="element-5316" />
      <WallOfLove data-id="element-5317" />
      <GettingStartedSteps data-id="element-5318" />
      <PricingSection data-id="element-5319" />
      <ClosingCTA data-id="element-5320" />
    </>;
}